import React, { useState } from "react";
import Badge from "../../components/ui-components/Badge.jsx";
import { authenticatedPost } from "../../api/authenticatedFetch";

const ENDPOINT = "/api/v1/forecast-predictability/reconstruct-matrix";

/**
 * ReconstructButton triggers a rebuild of the cold-start pooled conformal forecast matrix.
 * After the POST resolves it surfaces a compact summary (series · origins · rows) or a
 * "not enough history" notice when the backend signals there is insufficient data.
 */
const ReconstructButton = () => {
  const [busy, setBusy] = useState(false);
  const [last, setLast] = useState(null);
  const [error, setError] = useState(null);

  const handleRun = async () => {
    setError(null);
    setBusy(true);
    try {
      const body = await authenticatedPost(ENDPOINT);
      setLast(body);
    } catch (err) {
      setError("Rebuild failed. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const summaryLabel =
    last && last.ok
      ? `${last.n_series} series · ${last.n_origins} origins · ${last.n_rows.toLocaleString()} rows`
      : null;

  return (
    <div className="flex items-center gap-3 flex-wrap">
      <button
        type="button"
        onClick={handleRun}
        disabled={busy}
        className="px-4 py-1.5 text-sm rounded-ctrl bg-primary text-white hover:bg-primary-hover transition-colors disabled:opacity-40"
      >
        {busy ? "Rebuilding…" : "Rebuild cold-start forecast matrix"}
      </button>
      {last && last.ok && (
        <Badge label={summaryLabel} />
      )}
      {last && !last.ok && (
        <Badge label="Not enough history yet" />
      )}
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
};

export default ReconstructButton;
